import { render, staticRenderFns } from "./problem-classification.vue?vue&type=template&id=8a0ec128"
import script from "./problem-classification.vue?vue&type=script&lang=js"
export * from "./problem-classification.vue?vue&type=script&lang=js"
import style0 from "./problem-classification.vue?vue&type=style&index=0&id=8a0ec128&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports